import React, { Component } from 'react';
import Container from './components/common/application_container';
import { getUser } from './actions/session';
import axios from 'axios';
import CustomModal from './components/common/modal'
import { USER_COUNT, ALL_STATS, SYSTEM_STATS } from './config/rest_endpoints';
import AccountStats from './components/MainPage/accountStats';
import CarrierStats from './components/MainPage/carrierStats';
import { CircularProgressbar, buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { RC_LOAD_LOGIN } from './components/routers/RouteConstants';
import { withRouter } from 'react-router-dom';
import SystemStats from './components/MainPage/systemStats';
import DoughnutGraph from './components/common/graphs/doughnut';
import MixState from './components/MainPage/mixStats';
import MultiGraph from './components/MainPage/multiGraph';



class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            User: getUser(),
            totalUser: null,
            userPostpay: null,
            userPrePay: null,
            callCounts: {},
            isLogout: false,
            isExpire: false,
            account_Stats: [],
            carrier_Stats: [],
            system_Stats: [],
            userName:[],
            accountValues:[],
            monetryNames:[],
            monetryValues:[],
            accountsInfo:{}
        }
       
        this.goLoginPage = this.goLoginPage.bind(this)
    }

    componentWillMount() {
        this.getGraphStats()
        this.userActiveList()

    }

    componentDidMount() {
        this.interval = setInterval(() => {
            this.getGraphStats()
        }, 8000)
        this.userActiveList()
        // this.getSystemMonitor()

    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    openLogOutModal() {
        this.setState({ isExpire: true })
    }

    getSystemMonitor() {
        const { User } = this.state
        var headers = { "Authorization": "Bearer " + User.token };
        axios.get(SYSTEM_STATS, { headers }).then(res => {
            if (res) {
                var resp = res.data.data
                let resNames = Object.keys(resp.monetary[0])
                let resValues = Object.values(resp.monetary[0])
                this.setState({
                  monetryNames:resNames,
                  monetryValues:resValues

                })

            }
        }).catch(err => {
            console.log('err :>> ', err);
        })
    }

    // closeLogOutModal() {
    //     this.setState({ isExpire: false })
    // }

    userActiveList() {
        const { User } = this.state
        var headers = { "Authorization": "Bearer " + User.token };
        axios.get(USER_COUNT, { headers }).then(res => {
            if (res) {
                var resp = res.data.data
                let resNames = Object.keys(resp)
                let resValues = Object.values(resp)
                this.setState({
                    userName:resNames,
                    accountValues:resValues,
                    accountsInfo:resp
                    // totalUser: resp.total,
                    // userPostpay: resp.postpay,
                    // userPrePay: resp.prepay
                })
            }

        }).catch(err => {
            console.log('err :>> ', err);
        })
    }

    getGraphStats() {
        const { User, system_Stats } = this.state
        var headers = { "Authorization": "Bearer " + User.token };

        axios.get(ALL_STATS, { headers }).then(res => {
            if (res) {
                var resp = res.data.data
                this.setState({
                    account_Stats: resp.accounts,
                    carrier_Stats: resp.carriers,
                    system_Stats: resp.system
                })
            }
        }).catch(err => {
            console.log('err :>> ', err);
            var logs = err.response.status
            console.log('logs :>> ', logs);
            if (logs === 401 || logs === undefined) {
                localStorage.removeItem('user');
                this.setState({ isExpire: true })
                // this.props.history.push(RC_LOAD_LOGIN);
            }
        })
    }

    goLoginPage() {
        this.props.history.push(RC_LOAD_LOGIN)
    }


    render() {
        const { totalUser, userPostpay, userPrePay, callCounts, system_Stats, isExpire } = this.state
        var sessionStats = system_Stats.sessions/100;
        var cpsStats = system_Stats.CPS/100
        let logoutModal = {
            details: {
                info: "Session Expire",
                msg:
                    <div className="row">
                        <div className="col-md-12">
                            <div className="alert alert-warning alert-styled-left alert-dismissible">
                                <button type="button" className="close" data-dismiss="alert"></button>
                                <span className="font-weight-semibold">Opps Your session!</span> has expire please <a href="#" className="alert-link">login again</a>.
							    </div>
                        </div>

                        <button type="submit" className="btn bg-danger mr-2 ml-auto" onClick={this.goLoginPage}><i className="icon-key mr-2"></i>Login </button>

                    </div>
            },
            confirmBtn: { label: "Update", action: '' },
            crossBtn: { action: this.closeLogOutModal },
            cancelBtn: { label: "Cancel", action: this.closeLogOutModal }
        }

        const guageStyle = {
            height: 175,
        }

        return (
            <Container title="Home" title1="Dashboard" icon="fa fa-home" >
                <CustomModal
                    visibility={isExpire}
                    customBodyCSS={"h20"}
                    modalType={"danger"}
                    modalHeader={"danger"}
                    details={logoutModal.details}
                    showBtns={false}
                    cancelBtn={logoutModal.cancelBtn}
                    crossBtn={logoutModal.crossBtn}
                />
                <MixState systemStats={this.state.system_Stats} accountStats={this.state.accountsInfo}  />
                <MultiGraph />
                {/* <SystemStats stats={this.state.system_Stats}/> */}
                <div
                style={{borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.2)',border:'none'}}
                className="card border-left-dark-alpha border-right-dark-alpha text-center">
                        <h4 className="card-title mr-auto theme-title-design ml-0 m-2" style={{backgroundColor:'white',fontWeight:'',color:'#212529',fontSize:'22'}}>Accounts Calls</h4>
                    <div className="card-header header-elements-inline">

                    </div>
                    <div className="card-body" >
                        <AccountStats usersStats={this.state.account_Stats} />
                    </div>
                </div>
                <div
                style={{borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.2)',border:'none'}}
                className="card border-left-dark-alpha border-right-dark-alpha text-center">
                        <h4 className="card-title mr-auto theme-title-design ml-0 m-2" style={{backgroundColor:'white',fontWeight:'',color:'#212529',fontSize:'22'}}>Carriers Calls</h4>
                    <div className="card-header header-elements-inline">
                    </div>
                    <div className="card-body" >
                        <CarrierStats carrier={this.state.carrier_Stats} />
                    </div>
                </div>
            </Container>
        );
    }

}

export default withRouter(App)
